import { type FC } from "react";

// Markup transcribed from the design port kit (sections/Expertise.html). The
// photo is served from public/ so home.css and this src resolve the same path.
export const Expertise: FC = () => (
  <section className="built">
    <div className="wrap">
      <div className="builtgrid">
        <div>
          <h2>Industry expertise meets AI innovation.</h2>
          <p>Created by the industry experts who teach, mentor, and lead.</p>
          <p>
            Purpose-built for medical legal professionals to solve real
            challenges.
          </p>
        </div>
        <img
          className="drimg"
          alt="A physician writing evaluation notes"
          src="/images/home/expertise-portrait.jpg"
        />
      </div>
    </div>
  </section>
);
